import { render, staticRenderFns } from "./SubCompanies.vue?vue&type=template&id=4433066f&scoped=true"
import script from "./SubCompanies.vue?vue&type=script&lang=js"
export * from "./SubCompanies.vue?vue&type=script&lang=js"
import style0 from "./SubCompanies.vue?vue&type=style&index=0&id=4433066f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4433066f",
  null
  
)

export default component.exports